module.exports = __webpack_public_path__ + "static/media/logo-white.c5c21b15.svg";